/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {AbstractControl, FormArray, FormGroup} from '@angular/forms';

export function AnimalNumberPatternMatch(formArrayControlName: string) {
  return (formGroup: FormGroup | FormArray) => {
    const formArray: FormArray = formGroup.controls[formArrayControlName];

    if (formArray) {
      formArray.controls.forEach((fg: FormGroup) => {
        const numberControl: AbstractControl = fg.controls['number'];
        const embeddedControl: AbstractControl = fg.controls['_embedded'];

        if (numberControl && numberControl.value && embeddedControl && embeddedControl.value && embeddedControl.value.animalDetail) {
          numberControl.setErrors(new RegExp(embeddedControl.value.animalDetail.numberRegex).test(numberControl.value) ? null : {match: true});
        }
      });
    }
  };
}
